import { createElement, lazy } from 'react'

import { routes } from '../routes'
import RoleRestricted from '../utils/roleRestricted'
import { registerRoute } from '../utils/routeRegistry'

const NetworkOverview = lazy(() => import(/* webpackChunkName: 'network-overview' */ './containers/networkOverview'))

const initRoute = () => {
    registerRoute({
        path: routes.NETWORK_OVERVIEW,
        element: createElement(
            RoleRestricted,
            { allowedRoles: ['APPLICATION_ADMIN', 'MANAGER_PRINCIPAL_USED_CARS'] },
            createElement(NetworkOverview),
        ),
    })
}

export default initRoute
